import { compose, getContext, lifecycle } from 'recompose';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { FormSection } from 'redux-form';

const DynamicNameFormSectionContainer = compose(
  getContext({
    _reduxForm: PropTypes.object.isRequired,
  }),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const reduxForm = get(this.props, '_reduxForm');
      const oldNameRegexp = new RegExp(`^${this.props.name}`);

      if (!reduxForm.registeredFields || this.props.name === nextProps.name) {
        return;
      }

      Object.keys(reduxForm.registeredFields).forEach((fieldName) => {
        if (!fieldName.startsWith(this.props.name)) {
          return;
        }

        reduxForm.unregister(fieldName);
        reduxForm.register(fieldName.replace(oldNameRegexp, nextProps.name), 'Field');
      });
    },
  }),
);

export default DynamicNameFormSectionContainer(FormSection);
